import { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { globalLiveUpdatesSubPath, StorageKeys } from '../constants/storageKeys';
import { getFromLocalStorage } from '../internals/local-storage';
import { GlobalActions } from '../redux-store/thunks/global.thunks';

import type { RootState } from '../types/state.types';

export const useIsLiveUpdatesEnabled = (subId: string) => {
  const dispatch = useDispatch();

  const [finalIsLiveUpdatesEnabled, setFinalIsLiveUpdatesEnabled] = useState(false);

  const isLiveUpdatesEnabled = useSelector((state: RootState) => state.globals.enableLiveUpdates);

  useLayoutEffect(() => {
    const fromStorage = getFromLocalStorage(StorageKeys.liveUpdates, globalLiveUpdatesSubPath);
    const final = typeof fromStorage === 'boolean' ? fromStorage : isLiveUpdatesEnabled;

    setFinalIsLiveUpdatesEnabled(final);

    final
      ? dispatch(GlobalActions.enableLiveUpdatesGlobally(subId))
      : dispatch(GlobalActions.disableLiveUpdatesGlobally(subId));
  }, [subId, isLiveUpdatesEnabled]);

  return finalIsLiveUpdatesEnabled;
};
